import { default as _91_46_46_46404_93iEmxYyDxWTMeta } from "/builds/hatmeo/hatmeo-nuxt/pages/[...404].vue?macro=true";
import { default as cartNBq0aafCXuMeta } from "/builds/hatmeo/hatmeo-nuxt/pages/cart.vue?macro=true";
import { default as checkoutcmwXhYVpJKMeta } from "/builds/hatmeo/hatmeo-nuxt/pages/checkout.vue?macro=true";
import { default as _91id_93VhyRMHeAHtMeta } from "/builds/hatmeo/hatmeo-nuxt/pages/collections/[id].vue?macro=true";
import { default as indexYx4kIrRIdOMeta } from "/builds/hatmeo/hatmeo-nuxt/pages/index.vue?macro=true";
import { default as _91page_93tfJPI57ApAMeta } from "/builds/hatmeo/hatmeo-nuxt/pages/pages/[page].vue?macro=true";
import { default as _91sku_93Ot4SBN1jWNMeta } from "/builds/hatmeo/hatmeo-nuxt/pages/products/[sku].vue?macro=true";
import { default as searchvEbhA4BMUpMeta } from "/builds/hatmeo/hatmeo-nuxt/pages/search.vue?macro=true";
import { default as _91order_id_93YpfhOKcz4WMeta } from "/builds/hatmeo/hatmeo-nuxt/pages/success/[order_id].vue?macro=true";
export default [
  {
    name: "404",
    path: "/:404(.*)*",
    component: () => import("/builds/hatmeo/hatmeo-nuxt/pages/[...404].vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/builds/hatmeo/hatmeo-nuxt/pages/cart.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: checkoutcmwXhYVpJKMeta || {},
    component: () => import("/builds/hatmeo/hatmeo-nuxt/pages/checkout.vue")
  },
  {
    name: "collections-id",
    path: "/collections/:id()",
    component: () => import("/builds/hatmeo/hatmeo-nuxt/pages/collections/[id].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/hatmeo/hatmeo-nuxt/pages/index.vue")
  },
  {
    name: "pages-page",
    path: "/pages/:page()",
    component: () => import("/builds/hatmeo/hatmeo-nuxt/pages/pages/[page].vue")
  },
  {
    name: "products-sku",
    path: "/products/:sku()",
    component: () => import("/builds/hatmeo/hatmeo-nuxt/pages/products/[sku].vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/builds/hatmeo/hatmeo-nuxt/pages/search.vue")
  },
  {
    name: "success-order_id",
    path: "/success/:order_id()",
    meta: _91order_id_93YpfhOKcz4WMeta || {},
    component: () => import("/builds/hatmeo/hatmeo-nuxt/pages/success/[order_id].vue")
  }
]